import { render, staticRenderFns } from "./mobileA.vue?vue&type=template&id=4475a71b&scoped=true"
import script from "./mobileA.vue?vue&type=script&lang=js"
export * from "./mobileA.vue?vue&type=script&lang=js"
import style0 from "./mobileA.vue?vue&type=style&index=0&id=4475a71b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4475a71b",
  null
  
)

export default component.exports